/* OB card overrides: (1) rewrite Judge.me badge text to numeric rating, (2) flatten product card prices */
(function(){
  function rewriteRatings(){
    var badges = document.querySelectorAll('.card-wrapper .jdgm-prev-badge, .card-information .jdgm-prev-badge');
    badges.forEach(function(b){
      var rating = b.getAttribute('data-average-rating');
      if (!rating) return;
      var num = parseFloat(rating);
      if (isNaN(num) || num <= 0) return;
      var display = (Math.round(num * 100) / 100).toFixed(2);
      var txt = b.querySelector('.jdgm-prev-badge__text');
      if (txt && !txt.dataset.obRewritten) {
        txt.textContent = display + ' / 5';
        txt.style.fontWeight = '600';
        txt.style.color = '#1A1814';
        txt.dataset.obRewritten = '1';
        // Append "by Verified Buyers" subtitle if not present
        var parent = b;
        if (!parent.querySelector('.ob-rating__subtitle')) {
          var sub = document.createElement('span');
          sub.className = 'ob-rating__subtitle';
          sub.textContent = 'by Verified Buyers';
          parent.appendChild(sub);
        }
      }
      b.style.display = '';
    });
  }

  function flattenPrices(){
    // For each price-money inside a product card, replace its content with a single span containing the full price text.
    var moneys = document.querySelectorAll('.card-wrapper price-money, .card-information price-money');
    moneys.forEach(function(pm){
      if (pm.dataset.obFlattened === '1') return;
      var text = pm.textContent.trim();
      if (!text) return;
      pm.innerHTML = '<bdi><span class="ob-price-flat">' + text + '</span></bdi>';
      pm.dataset.obFlattened = '1';
    });
  }

  function run(){ rewriteRatings(); flattenPrices(); }

  document.addEventListener('DOMContentLoaded', function(){
    run();
    setTimeout(run, 200);
    setTimeout(run, 800);
    setTimeout(run, 1800);
    setTimeout(run, 4000);
    var obs = new MutationObserver(function(){ run(); });
    obs.observe(document.body, {childList: true, subtree: true});
  });
})();
